// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EQFH","type":"styles_type__2wLRM","choices":"styles_choices__322GM"};